export const knowledgebaseRoutes = {
  es: {
    workHours: 'configuración-de-horas-de-trabajo-del-proyecto'
  },
  en: {
    workHours: 'project-working-hours-setup'
  }
};
